var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal-default',{ref:"pauseNotificationModal",attrs:{"title":"","hide-close-button":""},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_c('button-default',{on:{"click":_vm.logout}},[_vm._v("Logout")])]},proxy:true}])},[_c('pause-confirmation')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }